module.exports = __webpack_public_path__ + "static/media/CadillacGothic-WideBold.woff";